import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { safeAnchorHref } from '../../../lib/link';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from '../ensigns/focus-ring';
import { SpecraIconTile } from '../ensigns/icon-tile';
import { SpecraHeading, SpecraText } from '../ensigns/typography';
/** Navigational card used by Delivery and cross-product hub screens. */ export function SpecraHubCard({ className, description, href, icon, onClick, renderLink, title, ...props }) {
    const sharedProps = {
        className: cn('block w-full rounded-lg border border-border bg-card p-4 text-left', (href || onClick) && `cursor-pointer transition-colors hover:bg-accent/50 ${specraFocusRing}`, className),
        ...props
    };
    const content = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            icon ? /*#__PURE__*/ _jsx(SpecraIconTile, {
                className: "mb-3 text-foreground",
                tone: "neutral",
                children: icon
            }) : null,
            /*#__PURE__*/ _jsx(SpecraHeading, {
                size: "sm",
                children: title
            }),
            description ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                className: "mt-1.5",
                size: "caption",
                tone: "muted",
                children: description
            }) : null
        ]
    });
    if (href && renderLink) {
        return renderLink({
            ...sharedProps,
            children: content,
            href
        });
    }
    const fallbackHref = href ? safeAnchorHref(href) : undefined;
    const Component = fallbackHref ? 'a' : onClick ? 'button' : 'div';
    const interactiveProps = fallbackHref ? {
        href: fallbackHref
    } : onClick ? {
        onClick,
        type: 'button'
    } : {};
    return /*#__PURE__*/ _jsx(Component, {
        ...sharedProps,
        ...interactiveProps,
        children: content
    });
}
